export const WIDESCREEN_BREAKPOINT = 1728;
export const MIDSCREEN_BREAKPOUNT = 1210;
export const TABLET_BREAKPOINT = 744;
export const PHONE_BREAKPOINT = 576;

export const MAX_RESOURCE_DESCRIPTION_LENGTH = 300;

export const NETLIFY_FUNCTION_BASE_PATH = "/.netlify/functions";
export const CONTACT_FUNCTION_PATH = NETLIFY_FUNCTION_BASE_PATH + "/contact";
